import { Component } from '@verndale/core';
import $ from 'jquery';
import { Loader } from '@googlemaps/js-api-loader';
import { BREAKPOINTS } from '../constants';

// Important: This was refactored the best way possible from the original MarineMax Galeon project
// There might be differences, but the code syntax is almost the same, adapted to the toolkit
// And removing all the original VUE js logic
// For more information take a look at the dealer-search.js coming from /Areas/Galeon/js
class Module extends Component {
  setupDefaults() {
    this.dom = {
      $dealerBtn: this.el.querySelectorAll('.dealer-search__show-map')
    };

    this.dealers = [];
    this.mapMarkers = [];
    this.selectedDealer = null;
    this.selectedSource = null;
    this.box = null;
    this.firstLoaded = false;
    this.scrollDealerId = null;
    this.previousZoom = null;

    // Fallback to test api key
    this.mapsKey =
      this.el.dataset.googleMapsApi ||
      'AIzaSyCs2ax90g4pVVd17c7cL_yE9opoGg6Mt4Q';

    this.initialWidth = window.innerWidth;

    this.isMobile = !window.matchMedia(
      `(min-width: ${BREAKPOINTS.DESKTOP_MAP}px)`
    ).matches;

    this.getDealerJSON();
    this.mapHandler();
  }

  addListeners() {
    this.dom.$dealerBtn.forEach(el => {
      el.addEventListener('click', this.showOnMap.bind(this));
    });

    window.addEventListener('resize', () => {
      if (this.initialWidth !== window.innerWidth) {
        this.updateMap(true);
        this.isMobile = !window.matchMedia(
          `(min-width: ${BREAKPOINTS.DESKTOP_MAP}px)`
        ).matches;
      }
    });
  }

  getDealerJSON() {
    const dealerJson = document.getElementById('dealer-search-json').innerText;

    if (dealerJson) {
      this.dealers = JSON.parse(dealerJson);
    }
  }

  async mapHandler() {
    const loader = new Loader({
      apiKey: this.mapsKey,
      version: 'weekly'
    });
    await loader
      .load()
      .then(google => {
        this.google = google;
      })
      .catch(e => {
        console.error('G Loader JS error', e);
      });

    const $dealerSearch = $('#dealerSearch');
    if ($dealerSearch.length) {
      $dealerSearch.find('.s-r').remove();
      this.setMap();
    }
  }

  setMap() {
    const dealerMap = document.getElementById('map');
    this.googleReady = true;

    this.mapObject = new this.google.maps.Map(dealerMap, {
      zoom: 14,
      mapTypeId: this.google.maps.MapTypeId.ROADMAP,
      center: { lat: 27.9659, lng: -82.8001 },
      gestureHandling: this.isMobile ? 'cooperative' : 'greedy',
      styles: [
        {
          featureType: 'administrative.country',
          elementType: 'geometry',
          stylers: [
            {
              visibility: 'simplified'
            },
            {
              hue: '#ff0000'
            }
          ]
        }
      ]
    });

    this.addMarkers();

    this.google.maps.event.addListener(this.mapObject, 'zoom_changed', () => {
      const zoom = this.mapObject.getZoom();

      if (this.mapMarkers && this.mapMarkers.length) {
        this.mapMarkers.forEach(marker => {
          marker.setIcon(zoom <= 5 ? marker.smallIcon : marker.largeIcon);
        });
      }
    });

    setTimeout(() => {
      $('.dealer-search__map-container').find('a').attr('tabindex', -1);
    }, 1000);
  }

  addMarkers() {
    const map = this.mapObject;
    let marker;

    this.mapMarkers = [];
    if (this.dealers.length) {
      this.dealers.forEach(dealer => {
        if (dealer && dealer.Latitude && dealer.Longitude) {
          marker = new this.google.maps.Marker({
            position: new this.google.maps.LatLng(
              dealer.Latitude,
              dealer.Longitude
            ),
            icon: this.getMarkerIcon(dealer),
            optimized: true,
            map,
            title: dealer.DisplayName
          });

          marker.dealer = dealer;
          marker.smallIcon = this.getSmallMarkerIcon(dealer);
          // eslint-disable-next-line no-multi-assign
          marker.icon = marker.largeIcon = this.getMarkerIcon(dealer);

          this.google.maps.event.addListener(
            marker,
            'click',
            (location => () => {
              this.scrollToDealer(location);
            })(dealer)
          );

          this.mapMarkers.push(marker);
        }
      });
      this.updateMap();
    }
  }

  getMarkerIcon(dealer) {
    const _scaledSize =
      this.selectedDealer && dealer.Id === this.selectedDealer.Id
        ? new this.google.maps.Size(54, 66)
        : new this.google.maps.Size(33, 41);

    return {
      url: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='33' height='41' viewBox='0 0 33 41'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg%3E%3Cg%3E%3Cg%3E%3Cpath fill='%2300416b' d='M16.404 0C2.84 0-2.446 12.403 1.046 22.086 4.086 30.524 16.399 40.8 16.399 40.8s12.31-10.259 15.356-18.707C35.244 12.408 29.965 0 16.404 0z' transform='translate(-638 -2455) translate(575 2353) translate(63 102)'/%3E%3Cpath fill='%23FFF' d='M22.14 15.91c0-3.378-2.753-6.118-6.149-6.118-3.398 0-6.151 2.74-6.151 6.119 0 3.381 2.753 6.121 6.151 6.121 3.396 0 6.149-2.74 6.149-6.121z' transform='translate(-638 -2455) translate(575 2353) translate(63 102)'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A",
      scaledSize: _scaledSize
    };
  }

  getSmallMarkerIcon(dealer) {
    const _scaledSize =
      this.selectedDealer && dealer.Id === this.selectedDealer.Id
        ? new this.google.maps.Size(33, 41)
        : new this.google.maps.Size(17, 22);

    return {
      url: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='33' height='41' viewBox='0 0 33 41'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg%3E%3Cg%3E%3Cg%3E%3Cpath fill='%2300416b' d='M16.404 0C2.84 0-2.446 12.403 1.046 22.086 4.086 30.524 16.399 40.8 16.399 40.8s12.31-10.259 15.356-18.707C35.244 12.408 29.965 0 16.404 0z' transform='translate(-638 -2455) translate(575 2353) translate(63 102)'/%3E%3Cpath fill='%23FFF' d='M22.14 15.91c0-3.378-2.753-6.118-6.149-6.118-3.398 0-6.151 2.74-6.151 6.119 0 3.381 2.753 6.121 6.151 6.121 3.396 0 6.149-2.74 6.149-6.121z' transform='translate(-638 -2455) translate(575 2353) translate(63 102)'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A",
      scaledSize: _scaledSize
    };
  }

  updateMap(forceUpdate) {
    const bounds = new this.google.maps.LatLngBounds();
    const map = this.mapObject;
    let updated = false;

    if (this.box && this.box.viewport) {
      bounds.extend(this.box.viewport.getSouthWest());
      bounds.extend(this.box.viewport.getNorthEast());
      updated = true;
    } else if (this.mapMarkers && this.mapMarkers.length) {
      this.mapMarkers.forEach(marker => {
        bounds.extend(marker.getPosition());
      });
      updated = true;
    }

    if (forceUpdate || updated) {
      map.fitBounds(bounds);
      map.setCenter(bounds.getCenter());
      this.google.maps.event.trigger(map, 'resize');
    }
  }

  scrollToDealer(dealer) {
    this.scrollDealerId = null;
    this.selectedDealer = dealer;
    this.selectedSource = 'map';
    this.updateMarkers();

    this.scrollDealerId = dealer.Id;

    const el = document.querySelector(`[id='${this.scrollDealerId}']`);

    if (!this.isMobile) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    } else {
      const yPos = el.getBoundingClientRect();
      window.scrollTo({
        top: yPos.y - 87,
        behavior: 'smooth'
      });
    }

    $('.dealer-search__dealer-card').removeClass('dealer-search__selected');
    $(el).addClass('dealer-search__selected');
  }

  showOnMap(dealer) {
    const dealerCard = $(dealer.target).closest('.dealer-search__dealer-card');
    const dealerId = dealerCard.attr('id');
    const selectedDealer = this.dealers.filter(el => el.Id === dealerId);
    // eslint-disable-next-line prefer-destructuring
    this.selectedDealer = selectedDealer[0];
    this.selectedSource = 'dealers';
    this.updateMarkers(true);

    this.scrollDealerId = dealerId;

    const el = document.querySelector(`[id='${this.scrollDealerId}']`);
    if (!this.isMobile) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    } else {
      window.scroll({
        behavior: 'smooth',
        top: 0
      });
    }

    $('.dealer-search__dealer-card').removeClass('dealer-search__selected');
    $(el).addClass('dealer-search__selected');
  }

  updateMarkers(recenterOnSelected) {
    let recenterLatLng;

    this.mapMarkers.forEach(marker => {
      marker.smallIcon = this.getSmallMarkerIcon(marker.dealer);
      marker.largeIcon = this.getMarkerIcon(marker.dealer);
      marker.setIcon(marker.largeIcon);
      if (
        recenterOnSelected &&
        this.selectedDealer &&
        marker.dealer.Id === this.selectedDealer.Id
      ) {
        recenterLatLng = marker.getPosition();
      }
    });

    if (recenterLatLng) {
      this.google.maps.event.trigger(this.mapObject, 'resize');
      this.mapObject.setZoom(16);
      this.mapObject.setCenter(recenterLatLng);
    }
  }

  clearMarkers() {
    this.mapMarkers.forEach(marker => {
      marker.setMap(null);
    });
    this.mapMarkers = [];
  }
}

export default Module;
